module.exports = "/assets/freebies/martini@2x.png?Nngt8Ke";